import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from './hooks/useLocalStorage';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from './pages/Login/reducer';
import { isEmpty, isNull } from 'lodash';
import { ROOT } from './utilities/roles';
import { findPermission } from './utilities/permission';
import { clearEdocSelections } from './pages/DocumentosElectronicos/reducer';
import { clearReportsState } from './pages/Reportes/reducer';
import { clearUserState } from './pages/Usuario/CrearUsuario/reducer';

export const GuardContext = React.createContext({});

const GuardProvider = (props) => {
    const navigate = useNavigate();

    const [session, setSession] = useLocalStorage('token', null);
    // const [, setApplicationState] = useLocalStorage('applicationState', null);
    const role = useSelector((state) => state.session.rol);
    const assignments = useSelector((state) => state.session.asignaciones);
    const username = useSelector((state) => state.session.username);
    const emisorSeleccionado = useSelector((state) => state.session.emisorSeleccionado);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isNull(session)) {
            setSession(null);
            logoutSystem();
            navigate('/');
            return;
        }

        if (!isNull(session) && (isEmpty(username) || isEmpty(role))) {
            const url = process.env.REACT_APP_BACKEND_URL + 'admin/me';
            axios
                .get(url, { headers: { Authorization: 'Bearer ' + session.token } })
                .then((response) => {
                    dispatch(
                        login({
                            username: response.data.nombre_usuario,
                            accesos: response.data.accesos,
                            rol: response.data.rol,
                            asignaciones: response.data.asignaciones,
                            empresa: response.data.empresa
                        })
                    );
                })
                .catch((error) => {
                    setSession(null);
                    logoutSystem();
                    navigate('/');
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate, session, setSession, dispatch, username, role, assignments]);

    const isOperationAllowed = (permission, issuer) => {
        //The root user has the ability to perform any action
        if (role === ROOT) {
            return true;
        }

        if (isEmpty(assignments)) {
            return false;
        }

        //If not issuer is provided, then we assign whatever issuer the user selected previously
        if (isEmpty(issuer)) {
            issuer = emisorSeleccionado.code;
        }
        const assignment = assignments[issuer];
        if (isEmpty(assignment?.permisos)) {
            return false;
        }

        //Other roles must have the necessary permission
        return findPermission(permission, assignment.permisos) > -1;
    };

    const logoutSystem = () => {
        dispatch(logout());
        dispatch(clearEdocSelections());
        dispatch(clearReportsState());
        dispatch(clearUserState());
        setSession(null);
        navigate('/');
    };

    const value = {
        isOperationAllowed,
        logoutSystem
    };

    return <GuardContext.Provider value={value}>{props.children}</GuardContext.Provider>;
};

export default GuardProvider;
